// extracted by mini-css-extract-plugin
export default {"card":"uZ-z","carouselContainer":"vZ-z","carouselContent":"wZ-z"};